import { createContext, useContext, useState, useEffect } from 'react'

const UserModeContext = createContext(null)

const STORAGE_KEY = 'osteo3d-books-user-mode'
const HINTS_KEY = 'osteo3d-books-dismissed-hints'

export function UserModeProvider({ children }) {
  const [mode, setModeState] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || 'accountant'
  })
  const [dismissedHints, setDismissedHints] = useState(() => {
    try { return JSON.parse(localStorage.getItem(HINTS_KEY) || '[]') }
    catch { return [] }
  })

  const setMode = (m) => {
    setModeState(m)
    localStorage.setItem(STORAGE_KEY, m)
  }

  const toggleMode = () => setMode(mode === 'simple' ? 'accountant' : 'simple')
  const isAccountant = mode === 'accountant'
  const isSimple = mode === 'simple'

  const dismissHint = (hintId) => {
    const next = [...dismissedHints, hintId]
    setDismissedHints(next)
    localStorage.setItem(HINTS_KEY, JSON.stringify(next))
  }

  const isHintDismissed = (hintId) => dismissedHints.includes(hintId)

  return (
    <UserModeContext.Provider value={{ mode, setMode, toggleMode, isAccountant, isSimple, dismissHint, isHintDismissed }}>
      {children}
    </UserModeContext.Provider>
  )
}

export function useUserMode() {
  const ctx = useContext(UserModeContext)
  if (!ctx) throw new Error('useUserMode must be inside UserModeProvider')
  return ctx
}
